<template>
  <h-legal-dialog
    url="/terms-and-conditions/demo"
    :title="__('legalConditions')"
  />
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import HLegalDialog from './ExternalContentDialog'

  export default {
    mixins: [
      I18n,
    ],

    components: {
      HLegalDialog,
    },
  }
</script>
